'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = VeganSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VeganSvg(props) {
    var size = props.size,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'outImgVegan', width: size, height: size, viewBox: '0 0 28 28', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-outline-vegan' },
        _react2.default.createElement(
            'title',
            { id: 'outImgVegan' },
            ' ',
            i18n.get('openrest_menubuilderv3_dishlabels_vegan') || 'vegan'
        ),
        _react2.default.createElement(
            'g',
            { fill: primaryColor },
            _react2.default.createElement('path', {
                d: 'M18.352 9.123c-.125.074-.226.178-.306.32l-3.918 8.484L9.975 9.44c-.15-.296-.378-.44-.693-.44-.194 0-.366.06-.526.18-.157.12-.234.27-.234.46 0 .122.02.218.057.278l4.725 9.676c.073.122.17.22.29.285.12.07.252.11.405.12.133-.002.274-.04.41-.114.136-.072.243-.18.32-.32l4.714-9.636c.052-.113.078-.216.078-.306 0-.17-.072-.312-.223-.43-.16-.12-.335-.178-.552-.178-.15 0-.278.036-.396.107z' }),
            _react2.default.createElement('path', {
                d: 'M14 26.666C7.015 26.666 1.333 20.984 1.333 14 1.333 7.015 7.015 1.332 14 1.332c6.984 0 12.666 5.683 12.666 12.666 0 6.984-5.682 12.666-12.666 12.666M14 0C6.28 0 0 6.28 0 14s6.28 14 14 14 14-6.28 14-14S21.72 0 14 0' })
        )
    );
}

VeganSvg.displayName = 'VeganSvg';
VeganSvg.propTypes = {
    size: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
VeganSvg.defaultProps = {
    size: 28,
    primaryColor: '#7ec77b'
};